module.exports = __webpack_public_path__ + "static/sales-sequences-2e202ec9fa77389845c14faa178b2296.png";